import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useTranslation, I18nextProvider } from 'react-i18next';
import Icon, { defaultColors } from '@digitransit-component/digitransit-component-icon';
import Shimmer from '@hsl-fi/shimmer';
import Modal from '@hsl-fi/modal';
import { createInstance } from 'i18next';

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles_input__mup3U {\n  width: 200px;\n}\n\n.styles_main-left__ixZGH {\n  display: flex;\n  order: 1;\n  flex-direction: column;\n  align-items: stretch;\n  background-color: #fff;\n  height: 100%;\n  width: calc(100% - 2em);\n  max-width: 399px;\n  z-index: 20;\n  margin: 0 auto;\n}\n\n.styles_main-bottom__M4zXb {\n  background-color: #fff;\n  width: calc(100% - 40px);\n  margin: 0 20px;\n  padding-bottom: 32px;\n}\n\n.styles_separator-div__0QdvP {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin-bottom: 25px;\n  padding-bottom: 21px;\n}\n@media screen and (min-width: 768px) {\n  .styles_separator-div__0QdvP {\n    padding-bottom: 31px;\n    margin-bottom: 20px;\n  }\n}\n\n.styles_separator-div2__CtWdO {\n  position: relative;\n  display: block;\n  width: 100%;\n  margin-bottom: 15px;\n  padding-bottom: 21px;\n}\n@media screen and (min-width: 768px) {\n  .styles_separator-div2__CtWdO {\n    margin-bottom: 26px;\n    padding-bottom: 21px;\n  }\n}\n\n.styles_separator-line__xZ3Qv {\n  background-color: #ccc;\n  content: \"\";\n  display: block;\n  height: 1px;\n  position: absolute;\n  bottom: 0;\n  right: -5px;\n  left: -5px;\n}\n@media screen and (min-width: 768px) {\n  .styles_separator-line__xZ3Qv {\n    right: -10px;\n    left: -10px;\n  }\n}\n\n.styles_separator__ksbHT {\n  background-color: #ccc;\n  width: var(--width);\n  margin-left: var(--margin);\n  margin-right: var(--margin);\n  height: 1px;\n}\n\n.styles_near-you-container__XFf0v {\n  font-size: 16px;\n}\n.styles_near-you-container__XFf0v .styles_modal-desc__VQjzC {\n  font-weight: 325;\n}\n.styles_near-you-container__XFf0v .styles_close-container__aXdg7 {\n  display: flex;\n  width: 100%;\n  height: 42px;\n  justify-content: right;\n}\n.styles_near-you-container__XFf0v .styles_close__tm-ay,\n.styles_near-you-container__XFf0v .styles_close-mobile__vDBSe {\n  display: flex;\n  height: 40px;\n  color: var(--color);\n  font-size: 16px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 20px;\n  background-color: white;\n  border-color: #888;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n.styles_near-you-container__XFf0v .styles_close__tm-ay {\n  width: 86px;\n}\n.styles_near-you-container__XFf0v .styles_close__tm-ay:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n.styles_near-you-container__XFf0v .styles_close-mobile__vDBSe {\n  width: 100%;\n}\n.styles_near-you-container__XFf0v .styles_near-you-title__FXRoy {\n  font-family: inherit;\n  font-weight: var(--font-weight);\n  line-height: normal;\n  letter-spacing: -0.67px;\n  color: #333;\n  font-size: 1.125em;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-title__FXRoy {\n    letter-spacing: -0.6px;\n    font-size: 1.25em;\n    margin: 0 0 18px 0;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS {\n  display: flex;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div:not(:last-child) {\n  margin-right: 7px;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div:not(:last-child) {\n    margin-right: 8px;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div:last-child {\n  margin-bottom: 32px;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 42px;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container__NKcMS > div {\n    min-width: 50px;\n    max-width: 72px;\n    height: 50px;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- {\n  border: solid 1px #ddd;\n  border-radius: 5px;\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  flex: 1;\n  width: 100%;\n  justify-content: center;\n  max-width: 72px;\n  height: 100%;\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg {\n  display: flex;\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- span.styles_transport-mode-alert-icon__7iMFH {\n  position: absolute;\n  bottom: -4px;\n  left: calc(50% + 10px);\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- span.styles_transport-mode-alert-icon__7iMFH svg {\n  height: 15px !important;\n  width: 15px !important;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- span.styles_transport-mode-alert-icon__7iMFH svg {\n    width: 18px !important;\n    height: 18px !important;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- svg {\n  width: 30px;\n  height: 30px;\n  margin: auto;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3- svg {\n    width: 34px;\n    height: 34px;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-button-with-border__80r3-:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- {\n  margin-bottom: var(--margin);\n  margin-top: var(--margin);\n  padding-bottom: var(--padding);\n  padding-top: var(--padding);\n  cursor: pointer;\n  display: flex;\n  background-color: white;\n  flex: 1;\n  min-width: 100%;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg {\n  cursor: pointer;\n  display: flex;\n  margin-left: var(--iconMargin);\n  border-radius: var(--borderRadius);\n  background-color: var(--bckColor);\n  height: var(--iconSize);\n  width: var(--iconSize);\n  align-items: center;\n  align-self: center;\n  justify-content: center;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH {\n  position: absolute;\n  top: 28px;\n  left: 32px;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg {\n  height: 15px !important;\n  width: 15px !important;\n}\n@media screen and (min-width: 768px) {\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg,\n  .styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_icon-container__qKWFg span.styles_transport-mode-alert-icon__7iMFH svg {\n    width: 18px !important;\n    height: 18px !important;\n  }\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O .styles_transport-mode-title__Yr0my,\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- .styles_transport-mode-title__Yr0my {\n  cursor: pointer;\n  font-style: normal;\n  font-weight: var(--font-weight);\n  font-size: 15px;\n  line-height: 18px;\n  margin-left: 9px;\n  align-self: center;\n  text-align: left;\n  width: calc(100% - 58px);\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-caret__1LEaK {\n  align-self: center;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button__1D89O:hover .styles_near-you-button-caret__1LEaK {\n  transform: translateX(4px);\n  transition: transform 0.1s;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3- {\n  border: solid 1px #d9d9d9;\n}\n.styles_near-you-container__XFf0v .styles_near-you-buttons-container-wide__2Z-wf .styles_near-you-button-with-border__80r3-:hover {\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n}";
var styles = {"input":"styles_input__mup3U","main-left":"styles_main-left__ixZGH","main-bottom":"styles_main-bottom__M4zXb","separator-div":"styles_separator-div__0QdvP","separator-div2":"styles_separator-div2__CtWdO","separator-line":"styles_separator-line__xZ3Qv","separator":"styles_separator__ksbHT","near-you-container":"styles_near-you-container__XFf0v","modal-desc":"styles_modal-desc__VQjzC","close-container":"styles_close-container__aXdg7","close":"styles_close__tm-ay","close-mobile":"styles_close-mobile__vDBSe","near-you-title":"styles_near-you-title__FXRoy","near-you-buttons-container":"styles_near-you-buttons-container__NKcMS","near-you-button-with-border":"styles_near-you-button-with-border__80r3-","icon-container":"styles_icon-container__qKWFg","transport-mode-alert-icon":"styles_transport-mode-alert-icon__7iMFH","near-you-buttons-container-wide":"styles_near-you-buttons-container-wide__2Z-wf","near-you-button":"styles_near-you-button__1D89O","transport-mode-title":"styles_transport-mode-title__Yr0my","near-you-button-caret":"styles_near-you-button-caret__1LEaK"};
styleInject(css_248z);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function NearYouButton({
  mode,
  modeSet,
  colors,
  getIconName,
  title,
  withAlert,
  boxed,
  withBorder,
  withArrow,
  margin,
  padding,
  iconSize
}) {
  let iconProps;
  if (mode === 'favorite') {
    iconProps = {
      img: 'star'
    };
  } else if (mode === 'more') {
    iconProps = {
      img: 'arrow',
      color: colors.primary,
      width: 1.2,
      height: 1.2
    };
  } else {
    iconProps = {
      img: getIconName(mode, modeSet, boxed),
      color: colors[mode]
    };
  }
  if (!boxed) {
    iconProps = _objectSpread(_objectSpread({}, iconProps), {}, {
      width: 1.4,
      height: 1.4
    });
  }
  const buttonStyle = {
    '--margin': margin,
    '--padding': padding
  };
  let iconContainerStyle = {
    '--iconSize': iconSize,
    '--iconMargin': padding
  };
  if (!boxed) {
    iconContainerStyle = _objectSpread(_objectSpread({}, iconContainerStyle), {}, {
      '--bckColor': colors[mode],
      '--borderRadius': '50%',
      '--iconMargin': '17px'
    });
  }
  const buttonClass = withBorder ? 'near-you-button-with-border' : 'near-you-button';
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: styles[buttonClass],
    style: buttonStyle
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['icon-container'],
    style: iconContainerStyle
  }, /*#__PURE__*/React.createElement(Icon, iconProps), withAlert && /*#__PURE__*/React.createElement("span", {
    className: styles['transport-mode-alert-icon']
  }, /*#__PURE__*/React.createElement(Icon, {
    img: "caution",
    color: colors.caution
  }))), title, withArrow && /*#__PURE__*/React.createElement("div", {
    className: styles['near-you-button-caret']
  }, /*#__PURE__*/React.createElement(Icon, {
    img: "arrow",
    color: colors.primary,
    width: 0.9,
    height: 0.9
  })));
}
process.env.NODE_ENV !== "production" ? NearYouButton.propTypes = {
  mode: PropTypes.string.isRequired,
  modeSet: PropTypes.string.isRequired,
  colors: PropTypes.objectOf(PropTypes.string).isRequired,
  getIconName: PropTypes.func.isRequired,
  title: PropTypes.node,
  withAlert: PropTypes.bool,
  boxed: PropTypes.bool,
  withBorder: PropTypes.bool,
  withArrow: PropTypes.bool,
  margin: PropTypes.string,
  padding: PropTypes.string,
  iconSize: PropTypes.string
} : void 0;
NearYouButton.defaultProps = {
  title: '',
  withAlert: false,
  boxed: false,
  withBorder: false,
  withArrow: false,
  margin: '8px',
  padding: '8px',
  iconSize: '30px'
};

function AllModesModal({
  appElement,
  modalOpen,
  closeModal,
  isMobile,
  language,
  fontWeights,
  colors,
  children
}) {
  const [t] = useTranslation();
  return /*#__PURE__*/React.createElement(Modal, {
    appElement: appElement,
    closeButtonLabel: (t('close'), {
      lng: language
    }),
    variant: isMobile ? 'large' : 'small',
    isOpen: modalOpen,
    onCrossClick: closeModal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['near-you-container'],
    style: {
      '--font-weight': fontWeights.medium
    }
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles['near-you-title']
  }, t('title', {
    lng: language
  })), !isMobile && /*#__PURE__*/React.createElement("div", {
    className: styles['modal-desc']
  }, t('description', {
    lng: language
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '20px'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['near-you-buttons-container-wide']
  }, children), !isMobile && /*#__PURE__*/React.createElement("div", {
    key: "",
    className: styles.separator,
    style: {
      '--margin': '-12%',
      '--width': '124%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['close-container']
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: closeModal,
    className: isMobile ? styles['close-mobile'] : styles.close,
    style: {
      '--color': colors.primary
    }
  }, t('close', {
    lng: language
  })))));
}
process.env.NODE_ENV !== "production" ? AllModesModal.propTypes = {
  appElement: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  fontWeights: PropTypes.shape({
    medium: PropTypes.number
  }).isRequired,
  colors: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired
} : void 0;

/* eslint sort-keys: "error" */
const translations = {
  de: {
    translation: {
      airplane: 'Flug',
      bus: 'Bus',
      citybike: 'Leihrad',
      close: 'Schließen',
      favorite: 'Favoriten',
      ferry: 'Fähre',
      rail: 'Zug',
      subway: 'U-Bahn',
      title: 'Haltestellen und Linien in der Nähe',
      tram: 'Straßenbahn'
    }
  },
  en: {
    translation: {
      airplane: 'Nearest airports',
      airplane_short: 'Airport',
      bikepark: 'Nearest bike Park & Ride sites',
      bikepark_short: 'Park & Ride (Bikes)',
      bus: 'Buses and nearby stops on a map',
      bus_short: 'Bus',
      carpark: 'Nearest car Park & ride sites',
      carpark_short: 'Park & Ride (Cars)',
      citybike: 'Nearest city bike stations',
      citybike_short: 'City bike',
      close: 'Close',
      description: 'The Near You view shows all stops and routes near you at a glance',
      favorite: 'Nearest favorites',
      favorite_short: 'Favorites',
      ferry: 'Nearest ferry piers',
      ferry_short: 'Ferry',
      more: 'Show more',
      rail: 'Trains and nearby stations on a map',
      rail_local: 'Commuter train',
      rail_short: 'Train',
      subway: 'Metro and nearby stations on a map',
      subway_short: 'Metro',
      title: 'Near you',
      tram: 'Trams and nearby stops on a map',
      tram_short: 'Tram'
    }
  },
  fi: {
    translation: {
      airplane: 'Lähimmät lentoasemat',
      airplane_short: 'Lentoasema',
      bikepark: 'Lähimmät liityntäpysäköinnit pyörille',
      bikepark_short: 'Liityntäpysäköinti pyörille',
      bus: 'Bussit ja lähipysäkit kartalla',
      bus_short: 'Bussi',
      carpark: 'Lähimmät liityntäpysäköinnit autoille',
      carpark_short: 'Liityntäpysäköinti autoille',
      citybike: 'Lähimmät kaupunkipyöräasemat',
      citybike_short: 'Kaupunkipyörä',
      close: 'Sulje',
      description: 'Lähelläsi -näkymä näyttää yhdellä kertaa pysäkit ja linjat lähelläsi',
      favorite: 'Lähimmät suosikit',
      favorite_short: 'Suosikit',
      ferry: 'Lähimmät lauttalaiturit',
      ferry_short: 'Lautta',
      more: 'Näytä lisää',
      rail: 'Junat ja lähiasemat kartalla',
      rail_local: 'Lähijuna',
      rail_short: 'Juna',
      subway: 'Metrot ja lähiasemat kartalla',
      subway_short: 'Metro',
      title: 'Lähelläsi',
      tram: 'Raitiovaunut ja lähipysäkit kartalla',
      tram_short: 'Raitiovaunu'
    }
  },
  pl: {
    translation: {
      airplane: 'Lot',
      bus: 'Autobus',
      citybike: 'Rower miejski',
      favorite: 'Przystanki w pobliżu',
      ferry: 'Prom',
      rail: 'Kolej',
      subway: 'Metro',
      sulje: 'Zamknij',
      title: 'Przystanki i trasy w pobliżu',
      tram: 'Tramwaj'
    }
  },
  sv: {
    translation: {
      airplane: 'De närmaste flygplatserna',
      airplane_short: 'Flygplatsen',
      bikepark: 'Anslutningsparkering för cyklar',
      bikepark_short: 'Anslutningsparkering för cyklar',
      bus: 'Bussar och närmaste hållplatser',
      bus_short: 'Buss',
      carpark: 'Anslutningsparkering för bilar',
      carpark_short: 'Anslutningsparkering för bilar',
      citybike: 'Närmaste stadscykelstationer',
      citybike_short: 'Stadscykel',
      close: 'Stäng',
      description: 'I vyn Nära dig kan du se hållplatserna och linjerna nära dig',
      favorite: 'Närmaste favoriter',
      favorite_short: 'Favoriter',
      ferry: 'Närmaste färjekajer',
      ferry_short: 'Färja',
      more: 'Visa flera',
      rail: 'Tåg och närmaste stationer',
      rail_local: 'Närtåg',
      rail_short: 'Tåg',
      subway: 'Metron och närmaste stationer',
      subway_short: 'Metro',
      title: 'Nära dig',
      tram: 'Spårvagnar och närmaste hållplatser',
      tram_short: 'Spårvagn'
    }
  }
};

const i18n = createInstance({
  fallbackLng: 'fi',
  // debug: true,
  resources: translations,
  defaultNS: 'translation',
  react: {
    useSuspense: true
  }
});
i18n.init();

const isKeyboardSelectionEvent = event => {
  const space = [13, ' ', 'Spacebar'];
  const enter = [32, 'Enter'];
  const key = event && (event.key || event.which || event.keyCode) || '';
  if (!key || !space.concat(enter).includes(key)) {
    return false;
  }
  event.preventDefault();
  return true;
};
function SeparatorLine({
  usePaddingBottom20
}) {
  const className = usePaddingBottom20 ? styles['separator-div2'] : styles['separator-div'];
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['separator-line']
  }));
}
process.env.NODE_ENV !== "production" ? SeparatorLine.propTypes = {
  usePaddingBottom20: PropTypes.bool
} : void 0;
SeparatorLine.defaultProps = {
  usePaddingBottom20: false
};

/**
 * Show button links to near you page for different travel modes
 *
 * @param {Object} props
 * @param {string[]} props.modeArray - Names of transport modes to show buttons for. Should be in lower case. Also defines button order
 * @param {string} props.language - Language used for accessible labels
 * @param {boolean} props.title - Custom titles per language
 * @param {Object} props.alertsContext
 * @param {function} props.alertsContext.getModesWithAlerts - Function which should return an array of transport modes that have active alerts (e.g. [BUS, SUBWAY])
 * @param {Number} props.alertsContext.currentTime - Time stamp with which the returned alerts are validated with
 * @param {Number} props.alertsContext.feedIds - feedIds for which the alerts are fetched for
 * @param {element} props.colors - theme color configuration
 * @param {string} props.urlPrefix - URL prefix for links
 * @example
 * const alertsContext = {
 *    getModesWithAlerts: () => ({}),
 *    currentTime: 123456789,
 *    feedIds: [HSL]
 * }
 * <CtrlPanel.NearStopsAndRoutes
 *      modeArray={['bus', 'tram', 'subway', 'rail', 'ferry', 'citybike']}
 *      language="fi"
 *      alertsContext={alertsContext}
 *    />
 *
 */

const validNearYouModes = ['favorite', 'bus', 'tram', 'rail', 'subway', 'airplane', 'ferry', 'citybike', 'bikepark', 'carpark'];
const noTheme = ['bikepark', 'carpark', 'subway', 'airplane']; // common icon in all themes

function getIconName(mode, modeSet, boxed) {
  const theme = noTheme.includes(mode) ? '' : `-${modeSet}`;
  const fill = boxed ? '' : '-fill'; // do not render boxed icon for vertical
  return `${mode}${fill}${theme}`;
}
const MAX_VISIBLE_MODES = 7;
function NearStopsAndRoutes({
  appElement,
  horizontal,
  modeArray,
  language,
  title,
  alertsContext,
  origin,
  onClick,
  modeSet,
  colors,
  fontWeights,
  isMobile,
  urlPrefix,
  omitLanguageUrl,
  loading
}) {
  const [modesWithAlerts, setModesWithAlerts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [t] = useTranslation();
  let urlStart;
  if (omitLanguageUrl) {
    urlStart = urlPrefix;
  } else {
    const urlParts = urlPrefix.split('/');
    urlParts.splice(urlParts.length - 1, 0, language);
    urlStart = urlParts.join('/');
  }
  useEffect(() => {
    if (alertsContext) {
      alertsContext.getModesWithAlerts(alertsContext.currentTime, alertsContext.feedIds).then(res => {
        setModesWithAlerts(res);
      });
    }
  }, []);
  const urlPostfix = origin.lat && origin.lon ? `/POS/${encodeURIComponent(origin.address)}::${origin.lat},${origin.lon}` : '/POS';
  const linkedButtonProps = {
    role: 'link',
    tabIndex: '0'
  };

  // line between buttons
  const separator = /*#__PURE__*/React.createElement("div", {
    className: styles['separator'],
    style: {
      '--margin': isMobile ? '0' : '-5%',
      '--width': isMobile ? '100%' : '110%'
    }
  });
  const renderButtons = (modes, forModal) => modes.map(mode => {
    const withAlert = modesWithAlerts.includes(mode.toUpperCase());
    const url = `${urlStart}/${mode.toUpperCase()}${urlPostfix}`;
    const boxed = forModal || horizontal; // squared icon or interior only
    const buttonProps = {
      mode,
      modeSet,
      colors,
      withAlert,
      boxed,
      getIconName
    };
    if (forModal || !horizontal) {
      let key = mode;
      if (forModal) {
        key = modeSet === 'hsl' && mode === 'rail' ? 'rail_local' : `${mode}_short`;
      }
      buttonProps.title = /*#__PURE__*/React.createElement("span", {
        className: styles['transport-mode-title'],
        style: {
          '--font-weight': forModal ? 325 : fontWeights.medium
        }
      }, t(key, {
        lng: language
      }));
    }
    if (!forModal) {
      buttonProps.withBorder = true;
    } else {
      buttonProps.withArrow = true;
      buttonProps.margin = '0';
      buttonProps.iconSize = '35px';
      buttonProps.padding = '6px';
    }
    const clickProps = mode === 'more' ? {
      onKeyDown: e => {
        if (isKeyboardSelectionEvent(e)) {
          setModalOpen(true);
        }
      },
      onClick: () => setModalOpen(true)
    } : {
      onKeyDown: e => {
        if (isKeyboardSelectionEvent(e)) {
          onClick(url, e);
        }
      },
      onClick: () => onClick(url)
    };
    const button = /*#__PURE__*/React.createElement("div", Object.assign({
      "aria-label": t(mode, {
        lng: language
      }),
      key: mode
    }, clickProps, linkedButtonProps), /*#__PURE__*/React.createElement(Shimmer, {
      active: loading
    }, /*#__PURE__*/React.createElement(NearYouButton, buttonProps)));

    // add separator line into modal button array
    return forModal && mode !== modes[modes.length - 1] ? /*#__PURE__*/React.createElement("div", {
      key: mode
    }, button, separator) : button;
  });
  const modes = modeArray.filter(mode => validNearYouModes.includes(mode));
  const useModal = horizontal && modes.length > MAX_VISIBLE_MODES;
  let visibleModes = modes;
  if (useModal) {
    visibleModes = modes.slice(0, MAX_VISIBLE_MODES - 1);
    visibleModes.push('more');
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['near-you-container'],
    style: {
      '--font-weight': fontWeights.medium
    }
  }, useModal && /*#__PURE__*/React.createElement(AllModesModal, {
    appElement: appElement,
    isMobile: isMobile,
    language: language,
    modalOpen: modalOpen,
    fontWeights: fontWeights,
    closeModal: () => setModalOpen(false),
    colors: colors
  }, renderButtons(modes, true)), /*#__PURE__*/React.createElement("h2", {
    className: styles['near-you-title']
  }, title?.[language] || t('title', {
    lng: language
  })), /*#__PURE__*/React.createElement("div", {
    className: horizontal ? styles['near-you-buttons-container'] : styles['near-you-buttons-container-wide']
  }, renderButtons(visibleModes, false)));
}
process.env.NODE_ENV !== "production" ? NearStopsAndRoutes.propTypes = {
  loading: PropTypes.bool,
  appElement: PropTypes.string.isRequired,
  modeArray: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.objectOf(PropTypes.string),
  language: PropTypes.string,
  horizontal: PropTypes.bool,
  alertsContext: PropTypes.shape({
    getModesWithAlerts: PropTypes.func,
    currentTime: PropTypes.number,
    feedIds: PropTypes.arrayOf(PropTypes.string)
  }),
  origin: PropTypes.shape({
    address: PropTypes.string,
    lat: PropTypes.number,
    lon: PropTypes.number
  }),
  onClick: PropTypes.func.isRequired,
  colors: PropTypes.objectOf(PropTypes.string),
  modeSet: PropTypes.string,
  fontWeights: PropTypes.shape({
    medium: PropTypes.number
  }),
  isMobile: PropTypes.bool,
  urlPrefix: PropTypes.string.isRequired,
  omitLanguageUrl: PropTypes.bool
} : void 0;
NearStopsAndRoutes.defaultProps = {
  loading: true,
  horizontal: true,
  language: 'fi',
  origin: undefined,
  alertsContext: undefined,
  title: undefined,
  colors: defaultColors,
  modeSet: 'hsl',
  fontWeights: {
    medium: 500
  },
  isMobile: false,
  omitLanguageUrl: false
};

/**
 * CtrlPanel gathers multiple components to same area (desktop-size: left or mobile-size: bottom)
 *
 * @example
 * <CtrlPanel language="fi" position="left">
 *    <CtrlPanel.SeparatorLine />
 *    <CtrlPanel.NearStopsAndRoutes
 *      modearray={['bus', 'tram', 'subway', 'rail', 'ferry', 'citybike']}
 *      language="fi"
 *    />
 *  </CtrlPanel>
 */
class CtrlPanel extends React.Component {
  render() {
    const className = this.props.position === 'bottom' ? styles['main-bottom'] : styles['main-left'];
    return /*#__PURE__*/React.createElement(I18nextProvider, {
      i18n: i18n
    }, /*#__PURE__*/React.createElement("div", {
      key: "main",
      className: className,
      style: {
        '--font-weight': this.props.fontWeights.medium
      }
    }, this.props.children));
  }
}
_defineProperty(CtrlPanel, "NearStopsAndRoutes", NearStopsAndRoutes);
_defineProperty(CtrlPanel, "SeparatorLine", SeparatorLine);
_defineProperty(CtrlPanel, "defaultProps", {
  children: [],
  fontWeights: {
    medium: 500
  }
});
process.env.NODE_ENV !== "production" ? CtrlPanel.propTypes = {
  children: PropTypes.node,
  position: PropTypes.string.isRequired,
  fontWeights: PropTypes.shape({
    medium: PropTypes.number
  })
} : void 0;

export { CtrlPanel as default };
//# sourceMappingURL=index.js.map
